export function getAuthState() {
	return !!sessionStorage.getItem('auth-token')
}
